export const ASSET_URL = process.env.AWS_S3_ASSET_URL;

export function assetUrl(path) {
    return `${ASSET_URL}/${path.replace(/^\//, '')}`;
}
